import React from "react";
/* img imports */
import waterJug from "../assets/images/jug/water-jug.png";
import waterFlow from "../assets/images/jug/water-flow.png";

const WaterJug = ({ handleWaterJugClick }) => {
  return (
    <>
      <div className="water-jug" onClick={handleWaterJugClick}>
        <img src={waterJug} alt="" />
      </div>
      <div className="water-flow">
        <img src={waterFlow} alt="" />
      </div>
    </>
  );
};

export default WaterJug;
